import React from 'react';

export function stringify(num1, num2) {
  return num1 + '' + num2;
}
